import * as React from "react"
import Layout from '../components/layout';
import { Scrollbar } from "react-scrollbars-custom";
import { Helmet } from "react-helmet";
import ReCAPTCHA from "react-google-recaptcha";
import useSiteMetadata from '../components/use-site-metadata';

// markup
export default (props) => {

  const { title } = useSiteMetadata();
  const { siteUrl } = useSiteMetadata();

  return (
    <Layout location={props.location}>
      <Helmet>
        <title>Comments</title>
        <meta itemprop="name" content={`${"Comments | "}${title}`}  />
        <meta name="twitter:title" content={`${"Comments | "}${title}`}  />
        <meta property="og:title" content={`${"Comments | "}${title}`}  />
        <link rel="canonical" href={`${siteUrl}${"/comments"}`} />
        <meta property="og:url" content={`${siteUrl}${"/comments"}`} />
      </Helmet>
      <section className="page-content-wrapper comments">
        <h1 style={{ display: 'none' }}>Comments</h1>
        <Scrollbar style={{ height: '100%' }} >

          <div className="row">
            <div className="col-12">
              <blockquote>
                <p>“The only way to undo racism is to constantly identify it and describe it—and then dismantle it.”</p>
                <cite>Ibram X. Kendi<br />“How to Be an Antiracist”</cite>
              </blockquote>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <h2>Ask yourself these questions:</h2>
              <p>What is the first step you, personally, will take in striving to be an anti-racist?</p>

              <p>How will you check yourself and hold yourself accountable if you notice that you, or someone else, is being racist?</p>

              <p>The Titans in this video series believe we can defy the odds, heal society of racism, and create an anti-racist society.</p>

              <p><strong>Do you?</strong></p>
              <p>Join the conversation and share your anti-racism journey so we all can strive for change.</p>
            </div>
            <div className="col-6">
            <h2>Tell Us About Your Journey Toward Anti-Racism</h2>

            <p>This is where you can express your thoughts about anti-racism, your journey and how you can make a change.</p>

            <CommentsForm />

            </div>
          </div>

        </Scrollbar>
      </section>
    </Layout>
  )
}

export class CommentsForm extends React.Component {
  constructor() {
    super();
    this.state = {
      sent: false,
      error: false,
      errorMSG: null,
      validEmail: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.handleLoad = this.handleLoad.bind(this);
  }


  validateEmail(event) {
    const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);

    event.preventDefault();
    const { name, value } = event.target;

    if (validEmailRegex.test(value)) {
      this.setState({ validEmail: true });
    } else {
      this.setState({ validEmail: false });
    }
  }
  
  componentDidMount() {
    window.addEventListener('load', this.handleLoad);
  }

  componentWillUnmount() { 
    window.removeEventListener('load', this.handleLoad)  
  }

  handleLoad() {

    var recaptchaTextarea = document.getElementById("g-recaptcha-response");
    recaptchaTextarea.setAttribute("aria-hidden", "true");
    recaptchaTextarea.setAttribute("aria-label", "Do not use");
    recaptchaTextarea.setAttribute("aria-readonly", "true");

    // check for iframes on page
    var elements = document.querySelectorAll('iframe');
    console.log(elements);
    if (elements.length > 0) {
      // loop through all found elements
      elements.forEach(function (element) {
        // set the title
        element.title = 'Google Recaptcha';
      });
    }

  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.validEmail) {
     
      const data = new FormData(event.target);
      
      // fetch('http://uawebstg.fullerton.edu/campaign/_api/index.php', {
      fetch('http://uawebstg.fullerton.edu/the-talk/_api/index.php', {
        method: 'POST',
        body: data,
      }).then((resp)=>{ 
        return resp.json() 
      }).then((json)=>{ 
        // console.log(json)
        if(json.success) {
          this.setState({ sent: true });
          this.setState({ error: false })
        } else {
          this.setState({ error: true });
          this.setState({ sent: false });
          this.setState({ errorMSG: json.errorMSG });
        }
      });
    } else {
      this.setState({ error: true });
      this.setState({ sent: false });
      this.setState({ errorMSG: 'Please enter a valid email address.' });
    }
  }

  render() {
    return (
      <React.Fragment>
        <form id="comments" onSubmit={this.handleSubmit}>

          <div className="form-group">
            <label htmlFor="name">Name: <span className="required">*</span></label>
            <input type="text" name="name" id="name" required />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email: <span className="required">*</span></label>
            <input type="email" name="email" id="email" required onChange={this.validateEmail} />
          </div>

          <div className="form-group">
            <label htmlFor="affiliation">Affiliation:</label>
            <select name="affiliation" id="affiliation">
              <option defaultValue>Select One</option>
              <option value="Student">Student</option>
              <option value="Faculty">Faculty</option>
              <option value="Staff">Staff</option>
              <option value="Alumni">Alumni</option>
              <option value="Community Member">Community Member</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="story">Your Story: <span className="required">*</span></label>
            <textarea name="story" id="story" required></textarea>
          </div>

          <label htmlFor="g-recaptcha-response">Recaptcha: <span className="required">*</span></label>
          <ReCAPTCHA
            id="recaptcha-container"
            style={{overflow: 'hidden'}}
            theme="dark"
            sitekey="6LeEAVQaAAAAAPAmDComkLykkYWWqiCqhDlGFEZM"
          />

          <input type="submit" value="Submit Story" />

        </form>
        <span className={ this.state.sent ? 'message success show' : 'message hidden' }>Thank you, your message has been sent.</span>
        <span className={ this.state.error ? 'message error show' : 'message hidden' }>{this.state.errorMSG}</span>
      </React.Fragment>
    );
  }
}